<template>
    <div>
        {{ translate("Choose or upload a temporary cover") }}
        <ul
            class="nav nav-pills nav-pills-sm nav-primary p-4 dm-cover-image-type-selector"
        >
            <li class="nav-item ml-0">
                <label
                    class="nav-link py-2 px-4 font-weight-bolder font-size-sm"
                    :class="{
                        active: presentation.cover_image_type == 'default',
                    }"
                >
                    <input
                        type="radio"
                        v-model="presentation.cover_image_type"
                        value="default"
                    />
                    {{ translate("Default") }}
                </label>
            </li>
            <li class="nav-item ml-0">
                <label
                    class="nav-link py-2 px-4 font-weight-bolder font-size-sm"
                    :class="{
                        active: presentation.cover_image_type == 'custom',
                    }"
                >
                    <input
                        type="radio"
                        v-model="presentation.cover_image_type"
                        value="custom"
                    />
                    {{ translate("Custom") }}
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState } from "pinia";
export default {
    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["presentation"]),
    },
};
</script>
